import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** 成本試算 detail（lines[] 依畫面順序；`record.updatedAt` 為下次寫入的版本）。 */
export async function fetchCostEstimateDetail(id) {
  const { data: raw } = await request.get(`/crm/cost-estimates/${id}`);
  return parseVer4DetailResponse(raw);
}
